export default __webpack_public_path__ + "static/media/icon-unvisible.8a94939f.svg";